export const getIds = (item: any) => {
    if (!item) return "";
    if (Array.isArray(item) && typeof item[0] === "number") {
        return item;
    }
    if (Array.isArray(item)) {
        return item.map((x) => x.id);
    }
    if (typeof item === "number") {
        return item;
    }
    return item.id ?? "";
};